import React, {ReactElement} from 'react';
import {ArrowIcon} from '../Icons';
import {IconSize} from '../Icons/IconWrapper';
import './OpenAndCloseArrow.scss';

interface Props {
  isOpen?: boolean;
  className?: string;
}

function OpenAndCloseArrow({isOpen, className}: Props): ReactElement {
  return (
    <ArrowIcon
      size={IconSize.LARGE}
      className={`openAndCloseArrow ${isOpen ? 'openAndCloseArrow--open' : ''} ${className || ''}`.trim()}
      testId="ui.icon.OpenAndCloseArrow"
    />
  );
}

export default OpenAndCloseArrow;
